import Session from "../auth/Session";

const WorkOrderFunctions = {
    getWorkOrdersAsync: async function (formData) {
        const token = Session.getToken();
        const response = await fetch(`api/WorkOrder/GetWorkOrders`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        return data;
    }
}

export default WorkOrderFunctions;